<template>
    <BasePromotionCard
        title="Rehearse the conversation"
        description="Try a quick role-play with Nadia before you have it for real."
        cta-label="Start a role-play"
        cta-href="/coach/start/">
        <template #icon>
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-5.13a4 4 0 11-8 0 4 4 0 018 0zm6 0a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
        </template>
        <template #draft>
            <div><span class="font-medium text-violet-800">Scenario:</span> {{ data.scenario }}</div>
            <div v-if="data.persona_hint" class="mt-1"><span class="font-medium text-violet-800">Counterpart:</span> {{ data.persona_hint }}</div>
        </template>
    </BasePromotionCard>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { PromoteRolePlayResult } from "../../types";
import BasePromotionCard from "./BasePromotionCard.vue";

const props = defineProps<{ result: PromoteRolePlayResult; toolName: string }>();

const data = computed<PromoteRolePlayResult>(() => props.result);
</script>
